<template>
	<div ref="el" data-component="landing" data-page="index.page">
		<div class="article-content-shell">
			<Header v-bind="headerPropsWithoutSideCta" />

			<main>
				<Body v-bind="bodySection" />
			</main>

			<div v-if="stickySideCta" class="article-cta-mobile">
				<div class="g-row">
					<div class="g-col xs-14 xs-offset-1">
						<div class="mobile-call-to-action">
							<p class="-headline-5 title">{{ stickySideCta.title }}</p>
							<Button v-bind="stickySideCta.cta" tone="primary" />
						</div>
					</div>
				</div>
			</div>

			<div v-if="stickySideCta" class="article-cta-rail">
				<div class="g-row rail-row">
					<div class="g-col xxl-3 xs-12 xs-offset-1 rail-col">
						<div class="sticky-call-to-action">
							<p class="-headline-5 title">{{ stickySideCta.title }}</p>
							<Button v-bind="stickySideCta.cta" tone="primary" />
						</div>
					</div>
				</div>
			</div>
		</div>

		<Footer v-bind="footer" />
	</div>
</template>

<script setup>
import { Header, Body } from './sections'
import { Footer } from '~/components/sections'
import { Button } from '~/components/primitives'

const props = defineProps({
	sections: { type: Array, default: undefined },
	footer: { type: Object, default: undefined },
})

const el = ref(null)
const sections = computed(() => (Array.isArray(props.sections) ? props.sections : []))

const getSection = (section) =>
	sections.value.find(
		(el) => (el.internalTitle && el.internalTitle.replace(/[-_\s]+(.)?/g, (_, c) => (c ? c.toUpperCase() : '')).replace(/^(.)/, (m) => m.toLowerCase()) === section) || el._type == section
	)

const headerSection = computed(() => getSection('header'))
const bodySection = computed(() => getSection('body'))
console.log(bodySection)

const stickySideCta = computed(() => headerSection.value?.sideCta)
const headerPropsWithoutSideCta = computed(() => {
	if (!headerSection.value) return undefined

	const { sideCta, ...rest } = headerSection.value
	return rest
})

onBeforeUnmount(() => {})
onMounted(() => {})
</script>

<style lang="scss" scoped>
[data-component='landing'] {
	position: relative;

	.article-content-shell {
		position: relative;
	}

	main {
		position: relative;
		z-index: 1;
	}

	.article-cta-mobile {
		display: none;
		visibility: hidden;
		pointer-events: none;
	}

	.article-cta-rail {
		position: absolute;
		inset: 0 0 rs(150, 150) 0;
		z-index: 4;
		pointer-events: none;

		.rail-row {
			height: 100%;
			align-items: stretch;
		}

		.rail-col {
			height: 100%;
			display: flex;
			flex-direction: column;
		}

		.sticky-call-to-action {
			position: sticky;
			bottom: rs(24, 24);
			margin-top: auto;

			width: column-width(3);
			display: flex;
			flex-direction: column;
			align-items: flex-start;

			pointer-events: auto;

			.title {
				margin-bottom: rs(15, 15);
			}
		}
	}

	@include max-width($sm) {
		.article-cta-rail {
			display: none;
			visibility: hidden;
			pointer-events: none;
		}
	}

	@include max-width($xs) {
		.article-cta-mobile {
			display: block;
			visibility: visible;
			pointer-events: auto;

			position: relative;
			z-index: 2;

			margin-top: rs(32, 32);
			margin-bottom: rs(56, 56);

			.mobile-call-to-action {
				display: flex;
				flex-direction: column;
				align-items: flex-start;

				.title {
					margin-bottom: rs(15, 15);
				}
			}
		}
	}
}
</style>
